export const dataTables = {
  data() {
    return {
      renderedComponent: true,
      tableClass: 'table-striped table-bordered responsive nowrap',
      tableInitOptions: {
        'bStateSave': true,
        stateSaveCallback: function (settings, data) {
          delete data.columns;
          localStorage.setItem('DataTables_' + settings.sInstance, JSON.stringify(data));
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(localStorage.getItem('DataTables_' + settings.sInstance));
        },
        destroy: true,
        responsive: true,
        details: false,
        select: true,
        bAutoWidth: false,
        language: {
          searchPlaceholder: 'Zoeken...',
          sProcessing: 'Bezig...',
          sLengthMenu: '_MENU_',
          sZeroRecords: 'Geen resultaten gevonden',
          sInfo: '_START_ tot _END_ van _TOTAL_ resultaten',
          sInfoEmpty: 'Geen resultaten om weer te geven',
          sInfoFiltered: ' (gefilterd uit _MAX_ resultaten)',
          sInfoPostFix: '',
          sSearch: '',
          sEmptyTable: 'Geen resultaten aanwezig in de tabel',
          sInfoThousands: '.',
          sLoadingRecords: 'Een moment geduld aub - bezig met laden...',
          oPaginate: {
            sFirst: 'Eerste',
            sLast: 'Laatste',
            sNext: 'Volgende',
            sPrevious: 'Vorige'
          },
          oAria: {
            sSortAscending: ': activeer om kolom oplopend te sorteren',
            sSortDescending: ': activeer om kolom aflopend te sorteren'
          }
        },
        drawCallback() {
          var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
          pagination.toggle(this.api().page.info().pages > 1);
        }
      }
    };
  },
  methods: {
    resetFilter(val) {

      _.each(val, v => {
        localStorage.removeItem(v);
      });
        _.each(this.customFilters, filter => {
            if(filter.options.values) {
                filter.options.values = [];
            }
            if(filter.options.range) {
                filter.options.range = {min: 0, max: 999999999};
            }
        });

    },

    renderComponent() {
      this.renderedComponent = false;

      this.$nextTick(() => {
        this.renderedComponent = true;
      });
    }
  },
  mounted() {
    // Overwrite Bootstrap dropdown Toggle
    $('.dropdown .dropdown-toggle').on('click', function () {
      $(this).parent().toggleClass('show');
      $(this).siblings().toggleClass('show');
    });
    $('body').on('click', function (e) {
      if(!$('.dropdown').is(e.target)
          && $('.dropdown').has(e.target).length === 0
          && $('.open').has(e.target).length === 0
      ) {
        $('.dropdown-menu').removeClass('show');
      }
    });
  }
};